module.exports = __webpack_public_path__ + "static/img/notice8.bada82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice8.png
// module id = PSg/
// module chunks = 2